import * as React from 'react';
import PropTypes from 'prop-types';
import ol_Map from 'ol/Map';
import { Util } from '../util';
import Map from '../map';

// I wish I can name it as 'layers', not 'Layers'
export class Controls extends React.Component {
    constructor(props) {
        super(props);
        this.options = {
            attribution: undefined,
            attributionOptions: undefined,
            rotate: undefined,
            rotateOptions: undefined,
            zoom: undefined,
            zoomOptions: undefined
        };
        this.options = Util.getOptions(Object['assign'](this.options, this.props));
    }
    render() {
        return (React.createElement("div", null, this.props.children));
    }
    componentDidMount() { }
    componentWillUnmount() { }
}
Controls['contextTypes'] = {
    map: PropTypes.instanceOf(ol_Map)
};